import React from 'react'
import styled from 'styled-components'
import Typography from '../../../components/Typography'
import { theme } from '../../../theme'

const PeopleTabs = ({ activeTab, tabs = [], onChange }) => {
  return (
    <Tabs>
      {tabs.map(tab => (
        <TabButton
          key={tab.id}
          type="button"
          className={activeTab === tab.id ? 'Active' : ''}
          onClick={() => onChange(tab.id)}
        >
          <Typography
            $variant="body-1-semibold"
            $variantMobile="body-2-semibold"
            color={activeTab === tab.id ? theme.colors.brandMain : theme.colors.defaultWeak}
          >
            {tab.label}
          </Typography>
        </TabButton>
      ))}
    </Tabs>
  )
}

export default PeopleTabs

const Tabs = styled.div`
  display: flex;
  width: 100%;
  gap: ${({ theme }) => theme.sizing.sm};
`

const TabButton = styled.button`
  border: none;
  border-bottom: 4px solid transparent;
  background: transparent;
  padding: 0 0 16px 0;
  cursor: pointer;

  &.Active {
    border-bottom-color: ${({ theme }) => theme.colors.brandMain};
  }
`
